import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="privacy" data-testid="privacy-page">
      <div className="wrap privacy-container">
        <div className="privacy-header">
          <h1>Privacy Policy</h1>
          <p className="privacy-updated">Last updated November 2026</p>
        </div>

        <section className="privacy-section">
          <h2>Information We Collect</h2>
          <p>When you contact us through our website, we collect information you provide directly to us, including:</p>
          <ul>
            <li>Name (first and last)</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Company name</li>
            <li>Service interests</li>
            <li>Project details and messages</li>
          </ul>
          <p>When you submit the form, we also record the date and time you gave consent to be contacted, the wording you agreed to, your browser's user agent, and a one-way hash of your IP address. We use these to keep a record of your consent and to prevent spam and abuse.</p>
          <p>If you become a client, we also store the information needed to provide our services through our client portal, such as your login email, project details, quotes, contracts, invoices and files you share with us.</p>
        </section>

        <section className="privacy-section">
          <h2>How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Respond to your inquiries by email or phone, and provide customer support</li>
            <li>Communicate with you about our services</li>
            <li>Improve our website and services</li>
            <li>Comply with legal obligations</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>Information Sharing</h2>
          <p>We do not sell, trade, or rent your personal information to third parties. We may share your information with:</p>
          <ul>
            <li>Service providers who process data on our behalf, listed below</li>
            <li>Professional advisors when necessary</li>
            <li>Law enforcement when required by law</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>Service Providers</h2>
          <p>We use the following providers to run our website, contact form and client portal. They process your information only to provide their services to us.</p>
          <ul>
            <li><strong>Supabase</strong>: stores contact form submissions and client portal data, and handles portal sign-in</li>
            <li><strong>Resend</strong>: sends emails, including contact form confirmations and client portal notifications</li>
            <li><strong>Cloudflare</strong>: hosts our website and client portal, stores files shared through the portal, and provides Turnstile spam protection</li>
            <li><strong>Cookiebot</strong> and <strong>PostHog</strong>: cookie consent and analytics, described below</li>
          </ul>
          <p>If you are a client, we also use Wave for quotes, invoices and payments, and Documenso for contracts and electronic signatures. You interact with these through links we send you, and they handle your information under their own privacy policies.</p>
        </section>

        <section className="privacy-section">
          <h2>Data Security</h2>
          <p>We implement appropriate technical and organizational measures to protect your personal information. However, no method of transmission over the Internet is 100% secure.</p>
        </section>

        <section className="privacy-section">
          <h2>Cookies and Analytics</h2>
          <p>We use Cookiebot to ask for your consent before setting any non-essential cookies. Cookiebot stores your choice in a cookie so we can remember it on later visits. You can change or withdraw your consent at any time through the cookie banner.</p>
          <p>If you accept statistics cookies, we use PostHog to understand how visitors use the site. PostHog collects usage data such as pages viewed, device and browser type, approximate location based on IP address, and session recordings of your interactions with the site. PostHog stores this data in the United States. If you decline, PostHog does not load.</p>
        </section>

        <section className="privacy-section">
          <h2>Cloudflare Turnstile</h2>
          <p>Our contact form uses Cloudflare Turnstile for security purposes. Cloudflare may collect certain information as described in their privacy policy.</p>
        </section>

        <section className="privacy-section">
          <h2>Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access the personal information we hold about you</li>
            <li>Request correction of inaccurate information</li>
            <li>Request deletion of your information</li>
            <li>Opt-out of marketing communications</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>Contact Us</h2>
          <p>If you have questions about this Privacy Policy or our data practices, please contact us at:</p>
          <p><strong>Email:</strong> inquire@rapidrune.com</p>
        </section>

        <div className="privacy-back">
          <a href="/" className="link-arrow" data-testid="privacy-back-link">
            Back to home
          </a>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
